import React from 'react';
export const SidebarPayables = ({ size = 16, className, 'data-testid': testId, fill = 'currentColor', 'aria-label': ariaLabel, }) => {
    return (React.createElement("svg", { "aria-label": ariaLabel, className: className, "data-testid": testId, fill: "none", height: size, width: size, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fill: fill, d: "M15 8.5a7 7 0 1 0-14 0 7 7 0 0 0 14 0Zm-7.5 4V6.425l-2.786 2.79L4 8.5l4-4 4 4-.696.715L8.5 6.425V12.5h-1Z" })));
};
